<script>
    import {
      Card,
      CardBody,
    } from "sveltestrap";
  
    // import { Link } from "svelte-routing";
  
    import leaders from "../../common/data/leaders.js";
    
  
  </script>
<Card>
<CardBody>
  <div class="mb-4 h4 card-title">Leaderboard</div>
  <div class="table-responsive">
    <table class="table align-middle table-nowrap mb-0">
        <thead class="table-light">
            <tr>
                <th class="align-middle">#</th>
                <th class="align-middle">Team Name</th>
                <th class="align-middle">Model Name</th>
                <th class="align-middle">Submission Date</th>
                <th class="align-middle">Accuracy</th>
                <th class="align-middle">Macro F1 score</th>
                <th class="align-middle"></th>
            </tr>
        </thead>
        <tbody>
          {#each leaders as leader}
            <tr>
                <td><a href="/" class="text-body fw-bold">{leader.num}</a> </td>
                <td>{leader.teamName}</td>
                <td>{leader.modelName}</td>
                <td>
                  {leader.submissionDate}
                </td>
                <td>
                  {leader.accuracy}
                </td>
                <td>
                  {leader.f1score}
                </td>
                <td>
                    <span class={"badge badge-pill badge-soft-" + leader.badgeclass + " font-size-11"}>{leader.etc}</span>
                </td>
            </tr>
            {/each}
        </tbody>
    </table>
    
</div>
</CardBody>
</Card>